import React, { useState } from 'react';
import {Container, Row, Col, Form, FormGroup, Label, Input, Button, Badge, Card, CardBody} from 'reactstrap';

// { showOthersSection = true }

const AddCandidate = () => {
 
  const [formData, setFormData] = useState({
    firstName: '', lastName: '', email: '', mobileNumber: '', alternateContact: '', dob: '',
    gender: '', maritalStatus: '', nationality: '', state: '', city: '', zipcode: '', address: '',
    totalExperience: '', currentJobTitle: '', currentEmployer: '', currentCTC: '', expectedCTC: '',
    noticePeriod: '', relocate: '', remoteWork: '', jobType: [],
    linkedIn: '', gitHub: '', portfolio: '',
    degree: '', specialization: '', passingYear: '', institute: '', eduCountry: '', grade: '',
    techSkills: [], softSkills: [], languages: [],
    resume: null, coverLetter: null, passportCopy: null, visa: null, academicCert: null,
    pan: '', aadhar: '', passportNumber: '', travelAbroad: '', workedAbroad: '', workedCountry: '', companyName: '',
    careerGap: '', gapMonths: '', gapReason: '',
    source: '', internalEmployeeId: ''
  });


const handleChange = (e) => {
  const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setFormData(prev => {
        const updated = prev[name] || [];
        return {
          ...prev,
          [name]: checked
            ? [...updated, value]
            : updated.filter(val => val !== value)
        };
      });
    } else if (type === 'file') {
      setFormData(prev => ({ ...prev, [name]: e.target.files[0] }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Submitting form:', formData);
  };

// skillset
  const techOptions = ['HTML', 'CSS', 'React', 'JavaScript'];
  const softOptions = ['Teamwork', 'Problem Solving', 'Communication', 'Active Listener'];
  const languageOptions = ['English', 'Telugu', 'Hindi', 'Tamil'];

  const [techSkills, setTechSkills] = useState([]);
  const [softSkills, setSoftSkills] = useState([]);
  const [languages, setLanguages] = useState([]);

  const [selectedTech, setSelectedTech] = useState('');
  const [selectedSoft, setSelectedSoft] = useState('');
  const [selectedLang, setSelectedLang] = useState('');

  const handleAdd = (value, setValue, list, setList) => {
    if (value !== 'Select' && !list.includes(value)) {
      setList([...list, value]);
    }
    setValue('');
  };

  const handleRemove = (item, list, setList) => {
    setList(list.filter(i => i !== item));
  };

//add assignment
 const uploadSections = [
    'Upload Resume* (PDF/DOC)',
    'Upload Cover Letter (Optional)',
    'Upload Passport Copy (for foreign hiring if applicable)',
    'Upload Work Authorization/Visa (if applicable)',
    'Upload Academic Certificates (Optional)'
  ];

return (    
// <div>
//   <AddNewCandidate showOthersSection={false} />
// </div>

<Container className="py-4 mb-5" style={{background:"#FFFFFF"}}>
        <Row className="mt-5">
         <Col>
         <p>View Job Postings/ JD1023/ Add Candidates</p>
          <h2 style={{ color: "#222222" }}>Add New Candidate</h2>
         </Col>                
        </Row>

      <Form onSubmit={handleSubmit}> 

 {/* 01 - General Information */}
 <h5 className="mb-3 pt-4">01 - General Information</h5>
 <Row form className="mb-4">
  <Col md={4}>
    <FormGroup>
      <Label for="firstName">First Name*</Label>
      <Input
        type="text"
        name="firstName"
        value={formData.firstName}
        onChange={handleChange}
        placeholder="First Name"
        className="rounded-3"
      />
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup>
      <Label for="lastName">Last Name*</Label>
      <Input
        type="text"
        name="lastName"
        value={formData.lastName}
        onChange={handleChange}
        placeholder="Last Name"
        className="rounded-3"
      />
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup>
      <Label for="email">Email*</Label>
      <Input
        type="email"
        name="email"
        value={formData.email}
        onChange={handleChange}
        placeholder="Email"
        className="rounded-3"
      />
    </FormGroup>
  </Col>
</Row>

<Row form className="mb-4">
  <Col md={4}>
    <FormGroup>
      <Label for="mobileNumber">Mobile Number*</Label>
      <Input
        type="text"
        name="mobileNumber"
        value={formData.mobileNumber}
        onChange={handleChange}
        placeholder="Mobile Number"
        className="rounded-3"
      />
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup>
      <Label for="alternateContact">Alternate Contact Number</Label>
      <Input
        type="text"
        name="alternateContact"
        value={formData.alternateContact}
        onChange={handleChange}
        placeholder="Mobile Number"
        className="rounded-3"
      />
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup>
      <Label for="dob">Date of Birth*</Label>
      <Input
        type="date"
        name="dob"
        value={formData.dob}
        onChange={handleChange}
        placeholder="DD-MM-YYYY"
        className="rounded-3"
      />
    </FormGroup>
  </Col>
</Row>

<Row form className="mb-4">
  <Col md={4}>
    <FormGroup>
      <Label for="gender">Gender</Label>
      <Input
        type="select"
        name="gender"
        value={formData.gender}
        onChange={handleChange}
        className="rounded-3"
      >
        <option>Select</option>
        <option>Male</option>
        <option>Female</option>
        <option>Other</option>
      </Input>
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup>
      <Label for="maritalStatus">Marital Status</Label>
      <Input
        type="select"
        name="maritalStatus"
        value={formData.maritalStatus}
        onChange={handleChange}
        className="rounded-3"
      >
        <option>Select</option>
        <option>Single</option>
        <option>Married</option>
      </Input>
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup>
      <Label for="nationality">Nationality</Label>
      <Input
        type="select"
        name="nationality"
        value={formData.nationality}
        onChange={handleChange}
        className="rounded-3"
      >
        <option>Select</option>
        <option>Indian</option>
        <option>Other</option>
      </Input>
    </FormGroup>
  </Col>
</Row>

<Row form className="mb-4">
  <Col md={4}>
    <FormGroup>
      <Label for="state">Province/State*</Label>
      <Input
        type="select"
        name="state"
        value={formData.state}
        onChange={handleChange}
        className="rounded-3"
      >
        <option>Select</option>
        <option>Telangana</option>
        <option>Karnataka</option>
      </Input>
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup>
      <Label for="city">City*</Label>
      <Input
        type="text"
        name="city"
        value={formData.city}
        onChange={handleChange}
        placeholder="City"
        className="rounded-3"
      />
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup>
      <Label for="zipcode">Zipcode*</Label>
      <Input
        type="text"
        name="zipcode"
        value={formData.zipcode}
        onChange={handleChange}
        placeholder="Zipcode"
        className="rounded-3"
      />
    </FormGroup>
  </Col>
</Row>

<Row form className="mb-4">
  <Col md={12}>
    <FormGroup>
      <Label for="address">Complete Address*</Label>
      <Input
        type="textarea"
        name="address"
        value={formData.address}
        onChange={handleChange}
        placeholder="Address"
        className="rounded-3"
      />
    </FormGroup>
  </Col>
</Row>

{/* 02 - Professional Details */}
<h5 className="mt-5 mb-3">02 - Professional Details</h5>
<Row form className="mb-4">
  <Col md={4}>
    <FormGroup>
      <Label className="fw-normal">Total Experience*</Label>
      <Input
        type="select"
        name="totalExperience"
        onChange={handleChange}
        className="rounded-3"
      >
        <option>Select Experience</option>
        {[...Array(31)].map((_, i) => (
          <option key={i}>{i}</option>
        ))}
      </Input>
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup>
      <Label className="fw-normal">Current Job Title*</Label>
      <Input
        name="currentJobTitle"
        onChange={handleChange}
        placeholder="Job Title"
        className="rounded-3"
      />
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup>
      <Label className="fw-normal">Current Employer</Label>
      <Input
        name="currentEmployer"
        onChange={handleChange}
        placeholder="Current Employer"
        className="rounded-3"
      />
    </FormGroup>
  </Col>
</Row>

<Row form className="mb-4">
  <Col md={4}>
    <FormGroup>
      <Label className="fw-normal">Current CTC</Label>
      <Input
        name="currentCTC"
        onChange={handleChange}
        placeholder="Current CTC"
        className="rounded-3"
      />
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup>
      <Label className="fw-normal">Expected CTC</Label>
      <Input
        name="expectedCTC"
        onChange={handleChange}
        placeholder="Expected CTC"
        className="rounded-3"
      />
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup>
      <Label className="fw-normal">Notice Period</Label>
      <Input
        name="noticePeriod"
        onChange={handleChange}
        placeholder="Notice Period"
        className="rounded-3"
      />
    </FormGroup>
  </Col>
</Row>

<Row form className="mb-4">
  <Col md={4}>
    <FormGroup>
      <Label className="fw-normal">Open to Relocate</Label>
      <Input
        type="select"
        name="relocate"
        onChange={handleChange}
        className="rounded-3"
      >
        <option>Select</option>
        <option>Yes</option>
        <option>No</option>
      </Input>
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup>
      <Label className="fw-normal">Open to Work Remotely</Label>
      <Input
        type="select"
        name="remoteWork"
        onChange={handleChange}
        className="rounded-3"
      >
        <option>Select</option>
        <option>Yes</option>
        <option>No</option>
      </Input>
    </FormGroup>
  </Col>
</Row>

<FormGroup className="mb-4">
  <Label className="fw-normal">Preferred Job Type</Label>
  <div>
    {['Full Time', 'Part Time', 'Contract', 'Internship'].map(type => (
      <FormGroup check inline key={type}>
        <Input
          type="checkbox"
          name="jobType"
          value={type}
          onChange={handleChange}
          className="me-1"
        />
        <Label check className="fw-normal">{type}</Label>
      </FormGroup>
    ))}
  </div>
</FormGroup>

<Row form className="mb-4">
  <Col md={4}>
    <FormGroup>
      <Label className="fw-normal">LinkedIn*</Label>
      <Input
        name="linkedIn"
        onChange={handleChange}
        placeholder="LinkedIn"
        className="rounded-3"
      />
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup>
      <Label className="fw-normal">GitHub</Label>
      <Input
        name="gitHub"
        onChange={handleChange}
        placeholder="GitHub"
        className="rounded-3"
      />
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup>
      <Label className="fw-normal">Portfolio/Website URL</Label>
      <Input
        name="portfolio"
        onChange={handleChange}
        placeholder="Portfolio/Website"
        className="rounded-3"
      />
    </FormGroup>
  </Col>
</Row>

{/* 03 - Educational Details */}
<h5 className="mt-5 mb-3">03 - Educational Details</h5>
<Row form className="mb-4">
  <Col md={4}>
    <FormGroup>
      <Label className="fw-normal">Highest Degree</Label>
      <Input
        type="select"
        name="degree"
        onChange={handleChange}
        className="rounded-3"
      >
        <option>Select Degree</option>
        <option>B.Tech</option>
        <option>M.Tech</option>
        <option>B.Sc</option>
        <option>MBA</option>
        <option>Other</option>
      </Input>
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup>
      <Label className="fw-normal">Specialization</Label>
      <Input
        name="specialization"
        onChange={handleChange}
        placeholder="Specialization"
        className="rounded-3"
      />
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup>
      <Label className="fw-normal">Year Of Passing</Label>
      <Input
        name="passingYear"
        onChange={handleChange}
        placeholder="Year Of Passing"
        className="rounded-3"
      />
    </FormGroup>
  </Col>
</Row>

<Row form className="mb-4">
  <Col md={4}>
    <FormGroup>
      <Label className="fw-normal">Institute Name</Label>
      <Input
        name="institute"
        onChange={handleChange}
        placeholder="Institute Name"
        className="rounded-3"
      />
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup>
      <Label className="fw-normal">Country</Label>
      <Input
        type="select"
        name="eduCountry"
        onChange={handleChange}
        className="rounded-3"
      >
        <option>Select</option>
        <option>India</option>
        <option>Other</option>
      </Input>
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup>
      <Label className="fw-normal">Grade/Percentage/CGPA</Label>
      <Input
        name="grade"
        onChange={handleChange}
        placeholder="Grade/Percentage/CGPA"
        className="rounded-3"
      />
    </FormGroup>
  </Col>
</Row>


  {/* 04 - Skills & Certifications */}
<h5 className="mt-5 mb-3">04 - Skills & Certifications</h5>

<Row form className="mb-4">     
      <Col md={4}>
        <FormGroup className="mb-4">
          <Label className="fw-normal">Key Technical Skills</Label>
          <Input
            type="select"
            value={selectedTech}
            onChange={(e) => handleAdd(e.target.value, setSelectedTech, techSkills, setTechSkills)}
            className="rounded-3"
          >
            <option>Select</option>
            {techOptions.map(skill => <option key={skill}>{skill}</option>)}
          </Input>
          <div className="mt-2 d-flex flex-wrap gap-2">
            {techSkills.map(skill => (
              <Badge
                key={skill}
                pill
                color="light"
                className="px-3 py-2 border rounded-5 d-flex align-items-center"
              >
                {skill}
                <span
                  onClick={() => handleRemove(skill, techSkills, setTechSkills)}
                  style={{ marginLeft: '8px', cursor: 'pointer', color: 'red', fontSize: '20px', lineHeight: '1' }}
                  aria-label="Remove skill"
                  role="button"
                >
                  &times;
                </span>
              </Badge>
            ))}
          </div>
        </FormGroup>
      </Col>
</Row>
      {/* Soft Skills */}
  <Row form className="mb-4">
      <Col md={4}>
        <FormGroup className="mb-4">
          <Label className="fw-normal">Soft Skills</Label>
          <Input
            type="select"
            value={selectedSoft}
            onChange={(e) => handleAdd(e.target.value, setSelectedSoft, softSkills, setSoftSkills)}
            className="rounded-3"
          >
            <option>Select</option>
            {softOptions.map(skill => <option key={skill}>{skill}</option>)}
          </Input>
          <div className="mt-2 d-flex flex-wrap gap-2">
            {softSkills.map(skill => (
              <Badge
                key={skill}
                pill
                color="light"
                className="px-3 py-2 border rounded-5 d-flex align-items-center"
              >
                {skill}
                <span
                  onClick={() => handleRemove(skill, softSkills, setSoftSkills)}
                  style={{ marginLeft: '8px', cursor: 'pointer', color: 'red', fontSize: '20px', lineHeight: '1' }}
                  aria-label="Remove skill"
                  role="button"
                >
                  &times;
                </span>
              </Badge>
            ))}
          </div>
        </FormGroup>
      </Col>
  </Row> 
      {/* Languages Known */}
  <Row form className="mb-4">
      <Col md={4}>
        <FormGroup className="mb-4">
          <Label className="fw-normal">Languages Known</Label>
          <Input
            type="select"
            value={selectedLang}
            onChange={(e) => handleAdd(e.target.value, setSelectedLang, languages, setLanguages)}
            className="rounded-3"
          >
            <option>Select</option>
            {languageOptions.map(lang => <option key={lang}>{lang}</option>)}
          </Input>
          <div className="mt-2 d-flex flex-wrap gap-2">
            {languages.map(lang => (
              <Badge
                key={lang}
                pill
                color="light"
                className="px-3 py-2 border rounded-5 d-flex align-items-center"
              >
                {lang}
                <span
                  onClick={() => handleRemove(lang, languages, setLanguages)}
                  style={{ marginLeft: '8px', cursor: 'pointer', color: 'red', fontSize: '20px', lineHeight: '1' }}
                  aria-label="Remove language"
                  role="button"
                >
                  &times;
                </span>
              </Badge>
            ))}
          </div>
        </FormGroup>
      </Col>
    </Row>

        {/* 05 - Resume & Supporting Documents */}
  <h5 className="mb-4">05 – Resume & Supporting Documents</h5>
   <Row>
        {uploadSections.map((section, index) => (
          <Col sm="12" md="6" lg="4" className="mb-5" key={index}>
            <Label className="font-weight-bold mb-3">{section}</Label>

            <Card
              className="h-100 text-center"
              style={{
                border: '1px dashed #3b82f6',
                backgroundColor: '#f5faff',
                borderRadius: '12px'
              }}
            >
              <CardBody
                className="d-flex flex-column justify-content-center align-items-center"
                style={{ minHeight: '110px', padding: '1.25rem' }}
              >
                <Input
                  type="file"
                  id={`file-upload-${index}`}
                  style={{ display: 'none' }}
                />
                <label
                  htmlFor={`file-upload-${index}`}
                  className="text-primary"
                  style={{ cursor: 'pointer' }}
                >
                  <div style={{ color: '#6b7280', fontSize: '14px' }}>
                    Drag & Drop files or{' '}
                    <span style={{ color: '#3b82f6', fontWeight: '500' }}>
                      Browse
                    </span>{' '}
                    files
                  </div>
                </label>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>

   {/* 06 - Additional Details */}
<h5 className="mt-5 mb-3">06 - Additional Details</h5>
<Row form>
  <Col md={4}>
    <FormGroup className="mb-4">
      <Label className="fw-normal">PAN Number</Label>
      <Input
        name="pan"
        placeholder="PAN Number"
        className="rounded-3"
        onChange={handleChange}
      />
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup className="mb-4">
      <Label className="fw-normal">Aadhar Number</Label>
      <Input
        name="aadhar"
        placeholder="Aadhar Number"
        className="rounded-3"
        onChange={handleChange}
      />
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup className="mb-4">
      <Label className="fw-normal">Passport Number (For International jobs)</Label>
      <Input
        name="passportNumber"
        placeholder="Passport Number"
        className="rounded-3"
        onChange={handleChange}
      />
    </FormGroup>
  </Col>
</Row>

<Row form>
  <Col md={4}>
    <FormGroup className="mb-4">
      <Label className="fw-normal">Willing to Travel Abroad?</Label>
      <Input
        type="select"
        name="travelAbroad"
        className="rounded-3"
        onChange={handleChange}
      >
        <option>Select</option>
        <option>Yes</option>
        <option>No</option>
      </Input>
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup className="mb-4">
      <Label className="fw-normal">Have You Ever Worked Abroad?</Label>
      <Input
        type="select"
        name="workedAbroad"
        className="rounded-3"
        onChange={handleChange}
      >
        <option>Select</option>
        <option>Yes</option>
        <option>No</option>
      </Input>
    </FormGroup>
  </Col>
</Row>

<Row form>
  <Col md={4}>
    <FormGroup className="mb-4">
      <Label className="fw-normal">Country Worked</Label>
      <Input
        type="select"
        name="workedCountry"
        className="rounded-3"
        onChange={handleChange}
      >
        <option>Select</option>
       <option>India</option>
        <option>Other</option>
      </Input>
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup className="mb-4">
      <Label className="fw-normal">Name of The Company</Label>
      <Input
        name="companyName"
        placeholder="Company"
        className="rounded-3"
        onChange={handleChange}
      />
    </FormGroup>
  </Col>
</Row>

<Row form>
  <Col md={4}>
    <FormGroup className="mb-4">
      <Label className="fw-normal">Any Gaps in Career?</Label>
      <Input
        type="select"
        name="careerGap"
        className="rounded-3"
        onChange={handleChange}
      >
        <option>Select</option>
        <option>Yes</option>
        <option>No</option>
      </Input>
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup className="mb-4">
      <Label className="fw-normal">No. Of Months With Gap</Label>
      <Input
        name="gapMonths"
        placeholder="No. Of Months With Gap"
        className="rounded-3"
        onChange={handleChange}
      />
    </FormGroup>
  </Col>
  <Col md={4}>
    <FormGroup className="mb-4">
      <Label className="fw-normal">Select a Reason For Gap</Label>
      <Input
        type="select"
        name="gapReason"
        className="rounded-3"
        onChange={handleChange}
      >
        <option value="">Select</option>
        <option value="education">Further Education</option>
        <option value="family_care">Family Care</option>
        <option value="job_search">Job Searching</option>
        <option value="travel">Other</option>
      </Input>
    </FormGroup>
  </Col>
</Row>
   <div className="d-flex justify-content-end mt-4">
      <Button color="secondary" className="px-5 p-2 rounded-4 border-dark">Close</Button>
      <Button type="submit" className="px-5 p-2 rounded-4 text-white ms-3" style={{background:"#006438"}}>Submit</Button>
   </div>
  </Form>
</Container>
  );
};

export default AddCandidate;
